import { Component, Inject, Optional } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';

@Component({
    selector: 'tt-facts',
    templateUrl: './facts.component.html',
    styleUrls: ['./facts.component.css'],
    standalone: false
})
export class FactsComponent {
    public readonly grid = new Grid()
        .setRememberId('w_facts_grid')
        .setLoadDataFunction({
            method: 2919,
            parameters: {}
        })
        .setConfig({ specialFunc: { newTab: true, buttons: [] } })
        .setKendoConfig({ height: '100%', sortable: true, aggregate: true, pager: false, selectable: false, filterable: false })
        .setCustomToolbarButtons([{ 
	        name: 'facts_new',
	        text: 'facts_new',
	        tooltip: 'facts_new',
	        translateTooltip: true,
	        func: () => this.navigator?.go({ to: 'factsedit', parms: { facts_id: '0' } }),
	        icon: 'fas fa-plus',
	        cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
	        translate: true
        }]);

    constructor(@Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator) {
        this.navigator = useNavigatorFor(navigator, this);

        if (this.grid.dataTask.removeRow) this.grid.dataTask.removeRow.confirm = false;
    }
}
